import { Input as DsInput } from '@repo/design-system/components/ui/input';
import { Textarea as DsTextarea } from '@repo/design-system/components/ui/textarea';

/**
 * Text fields (TS-1681): the design system's base Input and Textarea, copied from Hriq: a
 * bordered field on the page's own surface, which is what Hriq's app screens use on white
 * surfaces. The design system's v2 Input (white field, white border, a faint shadow) is
 * drawn for its grey modal and drawer surfaces; the CRM's fields mostly sit on white cards,
 * where it would all but disappear.
 */
export const Input = DsInput;
export const Textarea = DsTextarea;

/**
 * The same look for a native `<select>` (the few that are not the Radix Select): the design
 * system's field classes, with room for the browser's own arrow.
 */
export const nativeSelectClass =
  'border-input dark:bg-input/30 h-9 w-full min-w-0 rounded-md border bg-transparent px-3 pr-8 text-sm shadow-xs transition-[color,box-shadow] outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50';
